"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.addConsoleInstrumentationHandler = exports.CONSOLE_LEVELS = void 0;
var object_1 = require("../utils/object");
var utils_1 = require("../utils");
exports.CONSOLE_LEVELS = [
    'debug',
    'info',
    'warn',
    'error',
    'log',
    'assert',
    'trace',
];
function addConsoleInstrumentationHandler(handler) {
    if (!('console' in utils_1.GLOBAL_OBJ)) {
        return;
    }
    exports.CONSOLE_LEVELS.forEach(function (level) {
        if (!(level in utils_1.GLOBAL_OBJ.console)) {
            return;
        }
        (0, object_1.fill)(utils_1.GLOBAL_OBJ.console, level, function (originalConsoleMethod) {
            return function () {
                var args = [];
                for (var _i = 0; _i < arguments.length; _i++) {
                    args[_i] = arguments[_i];
                }
                var handlerData = { args: args, level: level };
                handler(handlerData);
                originalConsoleMethod &&
                    originalConsoleMethod.apply(utils_1.GLOBAL_OBJ.console, args);
            };
        });
    });
}
exports.addConsoleInstrumentationHandler = addConsoleInstrumentationHandler;
